import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const SCOPED_PATHS = new Set([
  "/tum-is-emirleri",
  "/taslak-is-emirleri",
  "/talep-is-emirleri",
  "/onayli-is-emirleri",
  "/iptal-is-emirleri",
  "/devam-eden-is-emirleri",
  "/pasif-devam-is-emirleri",
  "/tamamlanan-is-emirleri",
  "/musteri-listele",
  "/talep-ekle",
]);

const SCOPED_PREFIXES = ["/is-emri-duzenle/", "/talep-is-emri-duzenle/"];

function scopedPath(pathname) {
  const path = (pathname || "/").replace(/\/$/, "") || "/";
  return path.replace(/^\/eski/, "") || "/";
}

export default function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Yükleniyor…</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const path = scopedPath(location.pathname);
  const allowed = SCOPED_PATHS.has(path) || SCOPED_PREFIXES.some((prefix) => path.startsWith(prefix));
  if (user.tenant_id != null && user.tenant_id !== "" && !allowed) {
    return <Navigate to="/tum-is-emirleri" replace />;
  }

  return <Outlet />;
}
